import { ServiceFactory } from "../../services";
const moment = require("moment");
export default {
  state: {
    clients: [],
    products: [],
    client: {},
    currentBusiness: {},
    date1: "",
    date2: "",
    sidebarIsActive: true,
    clientComercialNameStore: ""
  },
  getters: {
    clientComercialNameStore: state => {
      return state.clientComercialNameStore;
    },
    subscribers: state => {
      return state.clients;
    },
    client: state => {
      return state.client;
    },
    products: state => {
      return state.products;
    },
    date1: state => {
      return state.date1;
    },
    date2: state => {
      return state.date2;
    },
    currentBusiness: state => {
      return state.currentBusiness;
    },
    sidebarIsActive: state => {
      return state.sidebarIsActive;
    }
  },
  mutations: {
    FillClientComercialNameStore(state, clientComercialNameStore) {
      state.clientComercialNameStore = clientComercialNameStore;
    },
    FillsidebarIsActive(state, sidebarIsActive) {
      state.sidebarIsActive = sidebarIsActive;
    },
    FillClients(state, clientsRequest) {
      state.clients = clientsRequest;
    },
    FillClient(state, clientRequest) {
      state.client = clientRequest;
    },
    FillProducts(state, products) {
      state.products = products;
    },
    FillDate1(state, date1) {
      state.date1 = moment(date1).format("YYYY-MM-DD");
    },
    FillDate2(state, date2) {
      state.date2 = moment(date2).format("YYYY-MM-DD");
    },
    SetCurrentBusiness(state, { subscriberId, businessUnitId }) {
      state.currentBusiness = {
        subscriberId,
        businessUnitId
      };
    }
  },
  actions: {
    GetClients: async function({ commit }, { page = 1, searchTerm, context }) {
      let SubscriberService = ServiceFactory.createInstance({
        type: "SubscriberService",
        data: context
      });
      const CLIENTS = await SubscriberService.GetClients({
        page,
        searchTerm
      });
      commit("FillClients", CLIENTS);
    },
    GetProducts: async function(
      { commit },
      { businessUnitId, subscriberId, context }
    ) {
      let SubscriberService = ServiceFactory.createInstance({
        type: "SubscriberService",
        data: context
      });

      const products = await SubscriberService.getProducts({
        businessUnitId,
        subscriberId
      });
      
      commit("FillProducts", products);
    }
  }
};
